var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images.length > 0)?_c('div',{staticClass:"banner-wrapper"},[_c('img',{staticClass:"ads-banner",attrs:{"src":_vm.currentImage.url}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }